
import { A2AAgent } from '../types';

export const specializedAgents: A2AAgent[] = [
  { 
    id: 'analytics-agent', 
    name: 'Analytics Specialist', 
    isAvailable: true, 
    capabilities: ['analytics', 'data-analysis', 'reporting', 'metrics-tracking'],
    description: 'Specialized in analyzing data and generating comprehensive reports',
    category: 'specialized',
    version: '1.0',
    interfaces: ['data-analysis', 'reporting'],
    maxConcurrentTasks: 3
  },
  { 
    id: 'scheduling-agent', 
    name: 'Scheduling Assistant', 
    isAvailable: true, 
    capabilities: ['calendar-coordination', 'scheduling', 'time-management', 'availability-checking'],
    description: 'Specialized in managing calendars and optimizing scheduling workflows',
    category: 'specialized',
    version: '1.0',
    interfaces: ['calendar-integration', 'scheduling'],
    maxConcurrentTasks: 5
  },
  { 
    id: 'negotiation-agent', 
    name: 'Negotiation Specialist', 
    isAvailable: true, 
    capabilities: ['negotiation', 'offer-management', 'compensation-analysis', 'contract-review'],
    description: 'Specialized in handling salary negotiations and contract terms',
    category: 'specialized',
    version: '1.0',
    interfaces: ['negotiation-support', 'offer-management'],
    maxConcurrentTasks: 2
  },
  {
    id: 'compliance-agent',
    name: 'Compliance Specialist',
    isAvailable: true,
    capabilities: ['compliance-checking', 'policy-enforcement', 'legal-review', 'documentation'],
    description: 'Ensures all processes comply with legal and company policies',
    category: 'specialized',
    version: '1.0',
    interfaces: ['compliance-validation'],
    maxConcurrentTasks: 3
  },
  {
    id: 'communication-agent',
    name: 'Communication Specialist',
    isAvailable: true,
    capabilities: ['email-automation', 'message-templates', 'communication-workflows', 'follow-up'],
    description: 'Manages automated communications and follow-up sequences',
    category: 'specialized',
    version: '1.0',
    interfaces: ['email-integration', 'messaging'],
    maxConcurrentTasks: 4
  },
  {
    id: 'integration-agent',
    name: 'Integration Specialist',
    isAvailable: true,
    capabilities: ['system-integration', 'api-management', 'data-sync', 'workflow-automation'],
    description: 'Handles integrations with external systems and platforms',
    category: 'specialized',
    version: '1.0',
    interfaces: ['api-integration', 'system-sync'],
    maxConcurrentTasks: 2
  }
];
